export default __webpack_public_path__ + "static/media/combo4.40ab2738.png";